// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__37zyj","paramInput":"JobSimulator_paramInput__3N-Ue","input":"JobSimulator_input__255x_"};